import Footer from "../../auth/layout/Footer";
import { useTranslation } from "react-i18next";

const ManulifeFooter = () => {
  const { t } = useTranslation("pages", { keyPrefix: "professionalIndemnity.footer" });
  return <Footer footer={t} />;
};
export default ManulifeFooter;
